import {
  ICreatedWorkflowTemplateVersionResponse,
  IWorkflowTemplateVersionMutationResult,
  TForkWorkflowTemplateVersionParams,
} from '@commenda/types';
import {
  fetcher,
  messageFromApiErrorResponse,
  readJsonResponseAs,
} from '@commenda/utils';
import { BASE_URL } from './helpers';

/** Copy a version into a fresh DRAFT and return the new version. */
export async function forkWorkflowTemplateVersion(
  params: Readonly<TForkWorkflowTemplateVersionParams>
): Promise<IWorkflowTemplateVersionMutationResult> {
  try {
    const res = await fetcher(`${BASE_URL}/version`, {
      method: 'POST',
      body: {
        workflowTemplateId: params.workflowTemplateId,
        starterTemplateVersionId: params.sourceWorkflowTemplateVersionId,
        versionNote: params.versionNote,
      },
    });

    if (!res.ok) {
      return {
        success: false,
        error: await messageFromApiErrorResponse(
          res,
          'Could not create a new version to edit.'
        ),
      };
    }

    const data =
      await readJsonResponseAs<ICreatedWorkflowTemplateVersionResponse>(res);
    if (!data?.workflowTemplateVersion?.id) {
      return {
        success: false,
        error: 'The new version was created but the server did not return it.',
      };
    }

    return { success: true, data };
  } catch {
    return {
      success: false,
      error: 'Could not reach the server to create a new version.',
    };
  }
}
